<template>
  <div
    style="   display: flex;
      flex-direction: row;
      align-items: center;color:#0F1A3A;font-size:12px;font-weight:bold;"
  >
    <kl-icon :size="20" :icon="icon" />
    <div style="margin-left: 7px">{{ title }}</div>
  </div>
</template>
<script>
export default {
  props: {
    title: {
      type: String,
      default: "",
    }, icon: {
      type: String,
      default: "",
    },
  },
};
</script>
